/**
*@title 엑스포 영상, 문의처, 엑스포 구성 요소
*@date 2022-02-07
*@author 권윤성
*@desc
*@etc(change)
*/

import React from 'react';
import { t } from 'i18next';

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';

const Video = () => {
    return(
        <div>
            <div className='main-vod-wrap'>
                <div className='main-vod-txt-box text-base md:text-xl'>
                    {t("main_video_title")}
                </div>
                <div className="main-vod-box">
                <iframe src="https://www.youtube.com/embed/-YtiU5Db9_c" title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen></iframe>
                </div>
            </div>
        </div>
    )

}

export default Video;